var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('span',[_vm._v("YES")]):_vm._e(),(!_vm.value)?_c('span',[_vm._v("NO")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }